export enum RULE_MESSAGE_TYPE {
	Info = 'Info',
	Warning = 'Warning',
	Error = 'Error'
}

export enum RULE_STATUS {
	NOT_REVIEWED = 0,
	FLAG = 1,
	PASSED = 2,
	FAILED = 3
}

export enum VIEW_COMMENTS_MODE {
	COMMENTS = 'comment',
	STIPS = 'stips'
}

export enum ORDER_STATE {
	APPROVED = 'Approved',
	REJECTED = 'Rejected',
	INQUALITY = 'UnderReview',
	CANCELLED = 'Cancelled'
}

export enum RULES_INDICATOR {
	COMPLETE = 'Completed',
	NODEFFERED = 'NoDeffered',
	INPROCESS = 'Inprocess'
}

export enum FORMTYPE {
	FORM1004 = '1004',
	FORM1073 = '1073',
	FORM1075 = '1075',
	FORM2055 = '2055',
	FREDDIE = 'FREDDIE',
	FNMA = 'FNMA',
	FORMSET_ALTVAL = 'FORMSET-CV'
}

export const isFORMSet = (form: string): boolean => {
	return /FORMSET-CV/.test(form);
}

export const RULE_UPDATED_EVENT = 'Rule Updated Event';
